import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/headless/examples/composer-with-attachments/composer-with-attachments.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
